<template>
  <v-container>
    <v-card>
      <v-card-header
        class="d-flex flex-column justify-center pa-5"
        style="align-items: center"
      >
        <v-img
          src="@/assets/images/logo.png"
          max-width="210"
          max-height="200"
          class="mb-5"
        ></v-img>
        <h1 class="text-center">Lorem ipsum</h1>
      </v-card-header>
      <v-card-text class="text-justify">
        <p>
          Lorem ipsum dolor sit amet. Non dolorem laborum non doloribus repellat
          eos nihil beatae hic ipsum laudantium? Eum consequatur dolorum a dolor
          dolores ut optio pariatur sed galisum perspiciatis et impedit porro id
          minus dicta. Ut velit illo aut esse natus ut necessitatibus aperiam ex
          alias dolores aut repudiandae dicta ut quaerat quam et unde
          perspiciatis. Et minus architecto est molestias temporibus et
          voluptates aliquid vel assumenda velit aut consequatur iusto ea
          eveniet nemo et vitae tempora.
        </p>
        <p>
          Ut velit illo aut esse natus ut necessitatibus aperiam ex alias
          dolores aut repudiandae dicta ut quaerat quam et unde perspiciatis. Et
          minus architecto est molestias temporibus et voluptates aliquid vel
          assumenda velit aut consequatur iusto ea eveniet nemo et vitae
          tempora. Et sapiente facilis qui consequuntur voluptatem ut dolorem
          distinctio? Ut velit illo aut esse natus ut necessitatibus aperiam ex
          alias dolores aut repudiandae dicta ut quaerat quam et unde
          perspiciatis. Et minus architecto est molestias temporibus et
          voluptates aliquid vel assumenda velit aut consequatur iusto ea
          eveniet nemo et vitae tempora. Et sapiente facilis qui consequuntur
          voluptatem ut dolorem distinctio? Ut velit illo aut esse natus ut
          necessitatibus aperiam ex alias dolores aut repudiandae dicta ut
          quaerat quam et unde perspiciatis. Et minus architecto est molestias
          temporibus et voluptates aliquid vel assumenda velit aut consequatur
          iusto ea eveniet nemo et vitae tempora. Et sapiente facilis qui
          consequuntur voluptatem ut dolorem distinctio? Ut velit illo aut esse
          natus ut necessitatibus aperiam ex alias dolores aut repudiandae dicta
          ut quaerat quam et unde perspiciatis. Et minus architecto est
          molestias temporibus et voluptates aliquid vel assumenda velit aut
          consequatur iusto ea eveniet nemo et vitae tempora. Et sapiente
          facilis qui consequuntur voluptatem ut dolorem distinctio? Ut velit
          illo aut esse natus ut necessitatibus aperiam ex alias dolores aut
          repudiandae dicta ut quaerat quam et unde perspiciatis. Et minus
          architecto est molestias temporibus et voluptates aliquid vel
          assumenda velit aut consequatur iusto ea eveniet nemo et vitae
          tempora. Et sapiente facilis qui consequuntur voluptatem ut dolorem
          distinctio? Ut velit illo aut esse natus ut necessitatibus aperiam ex
          alias dolores aut repudiandae dicta ut quaerat quam et unde
          perspiciatis. Et minus architecto est molestias temporibus et
          voluptates aliquid vel assumenda velit aut consequatur iusto ea
          eveniet nemo et vitae tempora. Et sapiente facilis qui consequuntur
          voluptatem ut dolorem distinctio? Ut velit illo aut esse natus ut
          necessitatibus aperiam ex alias dolores aut repudiandae dicta ut
          quaerat quam et unde perspiciatis. Et minus architecto est molestias
          temporibus et voluptates aliquid vel assumenda velit aut consequatur
          iusto ea eveniet nemo et vitae tempora. Et sapiente facilis qui
          consequuntur voluptatem ut dolorem distinctio? Ut velit illo aut esse
          natus ut necessitatibus aperiam ex alias dolores aut repudiandae dicta
          ut quaerat quam et unde perspiciatis. Et minus architecto est
          molestias temporibus et voluptates aliquid vel assumenda velit aut
          consequatur iusto ea eveniet nemo et vitae tempora. Et sapiente
          facilis qui consequuntur voluptatem ut dolorem distinctio? Ut velit
          illo aut esse natus ut necessitatibus aperiam ex alias dolores aut
          repudiandae dicta ut quaerat quam et unde perspiciatis. Et minus
          architecto est molestias temporibus et voluptates aliquid vel
          assumenda velit aut consequatur iusto ea eveniet nemo et vitae
          tempora. Et sapiente facilis qui consequuntur voluptatem ut dolorem
          distinctio? Ut velit illo aut esse natus ut necessitatibus aperiam ex
          alias dolores aut repudiandae dicta ut quaerat quam et unde
          perspiciatis. Et minus architecto est molestias temporibus et
          voluptates aliquid vel assumenda velit aut consequatur iusto ea
          eveniet nemo et vitae tempora. Et sapiente facilis qui consequuntur
          voluptatem ut dolorem distinctio? Ut velit illo aut esse natus ut
          necessitatibus aperiam ex alias dolores aut repudiandae dicta ut
          quaerat quam et unde perspiciatis. Et minus architecto est molestias
          temporibus et voluptates aliquid vel assumenda velit aut consequatur
          iusto ea eveniet nemo et vitae tempora. Et sapiente facilis qui
          consequuntur voluptatem ut dolorem distinctio? Ut velit illo aut esse
          natus ut necessitatibus aperiam ex alias dolores aut repudiandae dicta
          ut quaerat quam et unde perspiciatis. Et minus architecto est
          molestias temporibus et voluptates aliquid vel assumenda velit aut
          consequatur iusto ea eveniet nemo et vitae tempora. Et sapiente
          facilis qui consequuntur voluptatem ut dolorem distinctio? Ut velit
          illo aut esse natus ut necessitatibus aperiam ex alias dolores aut
          repudiandae dicta ut quaerat quam et unde perspiciatis. Et minus
          architecto est molestias temporibus et voluptates aliquid vel
          assumenda velit aut consequatur iusto ea eveniet nemo et vitae
          tempora. Et sapiente facilis qui consequuntur voluptatem ut dolorem
          distinctio? necessitatibus aperiam ex alias dolores aut repudiandae
          dicta ut quaerat quam et unde perspiciatis. Et minus architecto est
          molestias temporibus et voluptates aliquid vel assumenda velit aut
          consequatur iusto ea eveniet nemo et vitae tempora. Et sapiente
          facilis qui consequuntur voluptatem ut dolorem distinctio? Ut velit
          illo aut esse natus ut necessitatibus aperiam ex alias dolores aut
          repudiandae dicta ut quaerat quam et unde perspiciatis. Et minus
          architecto est molestias temporibus et voluptates aliquid vel
          assumenda velit aut consequatur iusto ea eveniet nemo et vitae
          tempora. Et sapiente facilis qui consequuntur voluptatem ut dolorem
          distinctio? Ut velit illo aut esse natus ut necessitatibus aperiam ex
          alias dolores aut repudiandae dicta ut quaerat quam et unde
          perspiciatis. Et minus architecto est molestias temporibus et
          voluptates aliquid vel assumenda velit aut consequatur iusto ea
          eveniet nemo et vitae tempora. Et sapiente facilis qui consequuntur
          voluptatem ut dolorem distinctio? Ut velit illo aut esse natus ut
          necessitatibus aperiam ex alias dolores aut repudiandae dicta ut
          quaerat quam et unde perspiciatis. Et minus architecto est molestias
          temporibus et voluptates aliquid vel assumenda velit aut consequatur
          iusto ea eveniet nemo et vitae tempora. Et sapiente facilis qui
          consequuntur voluptatem ut dolorem distinctio? Ut velit illo aut esse
          natus ut necessitatibus aperiam ex alias dolores aut repudiandae dicta
          ut quaerat quam et unde perspiciatis. Et minus architecto est
          molestias temporibus et voluptates aliquid vel assumenda velit aut
          consequatur iusto ea eveniet nemo et vitae tempora. Et sapiente
          facilis qui consequuntur voluptatem ut dolorem distinctio? Ut velit
          illo aut esse natus ut necessitatibus aperiam ex alias dolores aut
          repudiandae dicta ut quaerat quam et unde perspiciatis. Et minus
          architecto est molestias temporibus et voluptates aliquid vel
          assumenda velit aut consequatur iusto ea eveniet nemo et vitae
          tempora. Et sapiente facilis qui consequuntur voluptatem ut dolorem
          distinctio? Ut velit illo aut esse natus ut necessitatibus aperiam ex
          alias dolores aut repudiandae dicta ut quaerat quam et unde
          perspiciatis. Et minus architecto est molestias temporibus et
          voluptates aliquid vel assumenda velit aut consequatur iusto ea
          eveniet nemo et vitae tempora. Et sapiente facilis qui consequuntur
          voluptatem ut dolorem distinctio? Ut velit illo aut esse natus ut
          necessitatibus aperiam ex alias dolores aut repudiandae dicta ut
          quaerat quam et unde perspiciatis. Et minus architecto est molestias
          temporibus et voluptates aliquid vel assumenda velit aut consequatur
          iusto ea eveniet nemo et vitae tempora. Et sapiente facilis qui
          consequuntur voluptatem ut dolorem distinctio? Ut velit illo aut esse
          natus ut necessitatibus aperiam ex alias dolores aut repudiandae dicta
          ut quaerat quam et unde perspiciatis. Et minus architecto est
          molestias temporibus et voluptates aliquid vel assumenda velit aut
          consequatur iusto ea eveniet nemo et vitae tempora. Et sapiente
          facilis qui consequuntur voluptatem ut dolorem distinctio? Ut velit
          illo aut esse natus ut necessitatibus aperiam ex alias dolores aut
          repudiandae dicta ut quaerat quam et unde perspiciatis. Et minus
          architecto est molestias temporibus et voluptates aliquid vel
          assumenda velit aut consequatur iusto ea eveniet nemo et vitae
          tempora. Et sapiente facilis qui consequuntur voluptatem ut dolorem
          distinctio? Ut velit illo aut esse natus ut necessitatibus aperiam ex
          alias dolores aut repudiandae dicta ut quaerat quam et unde
          perspiciatis. Et minus architecto est molestias temporibus et
          voluptates aliquid vel assumenda velit aut consequatur iusto ea
          eveniet nemo et vitae tempora. Et sapiente facilis qui consequuntur
          voluptatem ut dolorem distinctio? necessitatibus aperiam ex alias
          dolores aut repudiandae dicta ut quaerat quam et unde perspiciatis. Et
          minus architecto est molestias temporibus et voluptates aliquid vel
          assumenda velit aut consequatur iusto ea eveniet nemo et vitae
          tempora. Et sapiente facilis qui consequuntur voluptatem ut dolorem
          distinctio? Ut velit illo aut esse natus ut necessitatibus aperiam ex
          alias dolores aut repudiandae dicta ut quaerat quam et unde
          perspiciatis. Et minus architecto est molestias temporibus et
          voluptates aliquid vel assumenda velit aut consequatur iusto ea
          eveniet nemo et vitae tempora. Et sapiente facilis qui consequuntur
          voluptatem ut dolorem distinctio? Ut velit illo aut esse natus ut
          necessitatibus aperiam ex alias dolores aut repudiandae dicta ut
          quaerat quam et unde perspiciatis. Et minus architecto est molestias
          temporibus et voluptates aliquid vel assumenda velit aut consequatur
          iusto ea eveniet nemo et vitae tempora. Et sapiente facilis qui
          consequuntur voluptatem ut dolorem distinctio? Ut velit illo aut esse
          natus ut necessitatibus aperiam ex alias dolores aut repudiandae dicta
          ut quaerat quam et unde perspiciatis. Et minus architecto est
          molestias temporibus et voluptates aliquid vel assumenda velit aut
          consequatur iusto ea eveniet nemo et vitae tempora. Et sapiente
          facilis qui consequuntur voluptatem ut dolorem distinctio? Ut velit
          illo aut esse natus ut necessitatibus aperiam ex alias dolores aut
          repudiandae dicta ut quaerat quam et unde perspiciatis. Et minus
          architecto est molestias temporibus et voluptates aliquid vel
          assumenda velit aut consequatur iusto ea eveniet nemo et vitae
          tempora. Et sapiente facilis qui consequuntur voluptatem ut dolorem
          distinctio? Ut velit illo aut esse natus ut necessitatibus aperiam ex
          alias dolores aut repudiandae dicta ut quaerat quam et unde
          perspiciatis. Et minus architecto est molestias temporibus et
          voluptates aliquid vel assumenda velit aut consequatur iusto ea
          eveniet nemo et vitae tempora. Et sapiente facilis qui consequuntur
          voluptatem ut dolorem distinctio? Ut velit illo aut esse natus ut
          necessitatibus aperiam ex alias dolores aut repudiandae dicta ut
          quaerat quam et unde perspiciatis. Et minus architecto est molestias
          temporibus et voluptates aliquid vel assumenda velit aut consequatur
          iusto ea eveniet nemo et vitae tempora. Et sapiente facilis qui
          consequuntur voluptatem ut dolorem distinctio? Ut velit illo aut esse
          natus ut necessitatibus aperiam ex alias dolores aut repudiandae dicta
          ut quaerat quam et unde perspiciatis. Et minus architecto est
          molestias temporibus et voluptates aliquid vel assumenda velit aut
          consequatur iusto ea eveniet nemo et vitae tempora. Et sapiente
          facilis qui consequuntur voluptatem ut dolorem distinctio? Ut velit
          illo aut esse natus ut necessitatibus aperiam ex alias dolores aut
          repudiandae dicta ut quaerat quam et unde perspiciatis. Et minus
          architecto est molestias temporibus et voluptates aliquid vel
          assumenda velit aut consequatur iusto ea eveniet nemo et vitae
          tempora. Et sapiente facilis qui consequuntur voluptatem ut dolorem
          distinctio? Ut velit illo aut esse natus ut necessitatibus aperiam ex
          alias dolores aut repudiandae dicta ut quaerat quam et unde
          perspiciatis. Et minus architecto est molestias temporibus et
          voluptates aliquid vel assumenda velit aut consequatur iusto ea
          eveniet nemo et vitae tempora. Et sapiente facilis qui consequuntur
          voluptatem ut dolorem distinctio? Ut velit illo aut esse natus ut
          necessitatibus aperiam ex alias dolores aut repudiandae dicta ut
          quaerat quam et unde perspiciatis. Et minus architecto est molestias
          temporibus et voluptates aliquid vel assumenda velit aut consequatur
          iusto ea eveniet nemo et vitae tempora. Et sapiente facilis qui
          consequuntur voluptatem ut dolorem distinctio?
        </p>
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script>
import Vue from "vue";

export default Vue.extend({
  name: "PoliticaPrivacidade",
  components: {},
});
</script>